import React, { useState, useEffect } from 'react';
import './RegularMenu.css';
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
const stripePromise = loadStripe('pk_test_your_publishable_key_here'); // Replace with your Stripe Publishable Key

const RegularMenu = () => {
  // -----------------------------
  // State Management
  // -----------------------------
  const [selectedItems, setSelectedItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);

  // Build Your Own Meal (BYO) states
  const [selectedBase, setSelectedBase] = useState('');
  const [selectedFavourites, setSelectedFavourites] = useState([]);
  const [selectedSauce, setSelectedSauce] = useState('');
  const [selectedExtras, setSelectedExtras] = useState([]);

  // State to manage expanded categories
  const [expandedCategories, setExpandedCategories] = useState({});

  // State for responsive view
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  // -----------------------------
  // Effect for Responsive Handling
  // -----------------------------
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuData = [
    // {
    //   id: 'chicken-burgers',
    //   name: 'Chicken Burgers',
    //   items: [
    //     { name: 'Big Flavour Burger', price: 6.95, ingredients: 'Fried Chicken Breast, fresh pickles & creamy mayo in a soft brioche bun', image: 'https://cdn.pixabay.com/photo/2019/01/21/12/47/burger-3946012_1280.jpg' },
    //     { name: 'Classic Chicken Sandwich', price: 7.95, ingredients: 'Fried chicken breast, cheddar cheese, lettuce, tomato, fresh pickles & creamy mayo in a soft brioche bun', image: 'https://cdn.pixabay.com/photo/2018/02/09/08/44/burger-3141127_960_720.jpg' },
    //     { name: 'Very Nashila Chicken Sandwich', price: 9.75, ingredients: 'Fried chicken breast, cheddar cheese, lettuce, tomato, fresh pickles & creamy mayo in a soft brioche bun', image: 'https://cdn.pixabay.com/photo/2023/05/29/17/01/hamburger-8026581_1280.jpg' },
    //     { name: 'Peri Peri Chicken Sandwich', price: 10.75, ingredients: 'Fried chicken breast, cheddar cheese, lettuce, tomato, fresh pickles & creamy mayo in a soft brioche bun and peri peri sauce', image: 'https://cdn.pixabay.com/photo/2023/05/29/17/01/hamburger-8026582_1280.jpg' },
    //   ],
    // },
    // {
    //   id: 'beef-burgers',
    //   name: 'Beef Burgers',
    //   items: [
    //     { name: 'House Cheese Smash Burger', price: 8.75, ingredients: 'Smash sauce, ketchup, onion & pickles', image: 'https://cdn.pixabay.com/photo/2022/07/15/18/17/spicy-burger-7323694_1280.jpg' },
    //     { name: 'Double Classic Smash', price: 8.75, ingredients: 'Smash sauce, ketchup, lettuce, tomato', image: 'https://cdn.pixabay.com/photo/2022/08/29/17/44/burger-7419419_1280.jpg' },
    //     { name: 'Ultimate Angus', price: 12.75, ingredients: 'Angus patty with cheddar cheese, fresh lettuce, tomatoes, pickles, and homemade burger sauce, served on a brioche bun', image: 'https://cdn.pixabay.com/photo/2022/07/15/18/17/spicy-burger-7323694_1280.jpg' },
    //   ],
    // },
    {
      id: 'wings-and-tenders',
      name: 'Chicken Wings & Tenders – Your Way',
      items: [
        { name: '5 Chicken Wings', price: 4.95, ingredients: 'Choose your glaze: Sweet Chilli, Peri Peri, Ketchup, Mayonnaise, Hot Sauce, Mango Sauce, House Sauce, Garlic Sauce, Blue Cheese Sauce', image: 'https://cdn.pixabay.com/photo/2022/11/07/15/47/chicken-wings-7576679_960_720.jpg' },
        { name: '10 Chicken Wings', price: 9.49, ingredients: 'Choose your glaze: Sweet Chilli, Peri Peri, Ketchup, Mayonnaise, Hot Sauce, Mango Sauce, House Sauce, Garlic Sauce, Blue Cheese Sauce', image: 'https://cdn.pixabay.com/photo/2017/06/26/13/58/chicken-2443901_1280.jpg' },
        { name: '4 Tender', price: 6.45, ingredients: 'Choose your glaze: Sweet Chilli, Peri Peri, Ketchup, Mayonnaise, Hot Sauce, Mango Sauce, House Sauce, Garlic Sauce, Blue Cheese Sauce', image: 'https://cdn.pixabay.com/photo/2020/06/13/16/26/barbecue-5294861_1280.jpg' },
        { name: '8 Tender', price: 12.00, ingredients: 'Choose your glaze: Sweet Chilli, Peri Peri, Ketchup, Mayonnaise, Hot Sauce, Mango Sauce, House Sauce, Garlic Sauce, Blue Cheese Sauce', image: 'https://cdn.pixabay.com/photo/2020/06/13/16/26/barbecue-5294861_1280.jpg' },
        { name: '4 Tender + Sides + Drinks', price: 10.95, ingredients: '', image: 'https://cdn.pixabay.com/photo/2016/07/31/17/51/chicken-1559548_1280.jpg' },
        { name: '8 Tender + 2 Sides + 2 Drinks', price: 19.00, ingredients: '', image: 'https://cdn.pixabay.com/photo/2016/07/31/17/51/chicken-1559548_1280.jpg' },
      ],
    },
    {
      id: 'corn-dogs',
      name: 'Corn Dogs',
      items: [
        { name: 'Original Corn Dog', price: 4.95, ingredients: 'Add any 3 sauces: Mayo, Ketchup, Mustard, Sweet Chilli, Wok & Chilli', image: 'https://cdn.pixabay.com/photo/2019/08/24/16/15/corn-dog-4427893_1280.jpg' },
        { name: 'Half & Half Corn Dog', price: 4.95, ingredients: 'Add any 3 sauces: Mayo, Ketchup, Mustard, Sweet Chilli, Wok & Chilli', image: 'https://cdn.pixabay.com/photo/2019/08/24/16/15/corn-dog-4427893_1280.jpg' },
        { name: 'Potato Corn Dog', price: 4.95, ingredients: 'Add any 3 sauces: Mayo, Ketchup, Mustard, Sweet Chilli, Wok & Chilli', image: 'https://staticcookist.akamaized.net/wp-content/uploads/sites/22/2022/08/korean-corn-dogs.jpg' },
        { name: 'Potato & Mozzarella Corn Dog', price: 4.95, ingredients: 'Add any 3 sauces: Mayo, Ketchup, Mustard, Sweet Chilli, Wok & Chilli', image: 'https://i.ytimg.com/vi/oqdAEvUmbPk/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAbmmOxqARbSJws0mvex0AOgdCEKw' },
      ],
    },
    {
      id: 'meal-deals',
      name: 'Meal Deals',
      items: [
        { name: 'Wok & Fire Meal Box Special', price: 9.95, ingredients: 'Any base, 2 favourites, Free Sauce and Drinks', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s' },
        { name: 'Wings Meal Deal (5 Wings)', price: 9.95, ingredients: '5 Wings + Sides + Drinks', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s' },
        { name: 'Wings Meal Deal (10 Wings)', price: 18.99, ingredients: '10 Wings + 2 Sides + 2 Drinks', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s' },
        { name: 'Corn Dog Meal Deal', price: 8.85, ingredients: 'Any Corn Dogs Fries, Drinks', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s' },
        { name: 'Tender Meal Deal (9 Tenders)', price: 11.95, ingredients: '9 Tenders + Sides + Drinks', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s' },
        { name: 'Tender Meal Deal (10 Tenders)', price: 20.99, ingredients: '10 Tenders + 2 Sides + 2 Drinks', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s' },
        { name: 'Family Meal', price: 45.99, ingredients: '1 Beef, 2 Chicken Burger, 1 Wok & Fire Meal Box, 8 wings + 2 chips, 4 drinks', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s' },
        { name: 'Kids Tender Meal', price: 6.50, ingredients: '2 Tender + Sides + Drinks', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s' },
        { name: 'Kids Chicken', price: 6.50, ingredients: '2 Wings + Sides + Drinks', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s' },
        { name: 'Sandwich Meal', price: 7.95, ingredients: 'Classic Sandwich + Sides + Drinks', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnR-OBt49C0aqTEUwP-UJHvFIFaMsvnrggUw&s' },
      ],
    },
    {
      id: 'curries',
      name: 'Curries',
      items: [
        { name: 'Chicken Curry', price: 12.50, ingredients: 'Vibrant Mixed Peppers, Pak Choi, Asian Special Spices with Special Fire Curry Sauce, Garnish with Coriander', image: 'https://cdn.pixabay.com/photo/2020/08/07/19/19/chili-chicken-5471405_1280.jpg' },
        { name: 'Beef Curry', price: 12.50, ingredients: 'Fresh Chillies, Lettuce, Sharp White Onions, Black Pepper with Oyster Sauce, & Special Fire Curry Sauce, Garnish with Coriander', image: 'https://www.kitchensanctuary.com/wp-content/uploads/2015/09/Spicy-Beef-Curry-square.jpg' },
      ],
    },
    {
      id: 'sides',
      name: 'Sides',
      items: [
        { name: 'Plain Chips', price: 3.25, ingredients: '', image: 'https://images.pexels.com/photos/1583884/pexels-photo-1583884.jpeg' },
        { name: 'Cheesy Chips', price: 4.25, ingredients: '', image: 'https://www.effortlessfoodie.com/wp-content/uploads/2022/01/cheesy-chips-5.jpg' },
        { name: 'Masala Chips', price: 4.45, ingredients: '', image: 'https://mymorningmocha.com/wp-content/uploads/2024/03/masala-chips.jpg' },
      ],
    },
    {
      id: 'drinks',
      name: 'Drinks',
      items: [
        { name: 'Coca Cola', price: 'Start from £1.95', ingredients: '', image: 'https://aytacwholesale.co.uk/cdn/shop/files/Drinks-cola.png?v=1745917071&width=640' },
        { name: 'Coca Cola Zero', price: 'Start from £1.95', ingredients: '', image: 'https://www.coca-cola.com/content/dam/onexp/gb/en/brands/coca-cola-zero-sugar/Product-Information-Section-coca-cola-zero-sugar.jpg' },
        { name: 'Sprite', price: 'Start from £1.95', ingredients: '', image: 'https://www.aspris.co.uk/wp-content/uploads/2017/07/Sprite-330ml-scaled.jpg' },
        { name: 'Fanta Orange / Apple Juice', price: 'Start from £1.95', ingredients: '', image: 'https://www.onestop.co.uk/wp-content/uploads/18d58c52-b1b4-4f2b-a1cb-687da3e7e0e8.png' },
        { name: 'Fresh Orange / Apple Juice', price: 'Start from £1.95', ingredients: '', image: 'https://cdn.pixabay.com/photo/2016/12/20/21/43/orange-1921548_960_720.jpg' },
        { name: 'Ice Tea Lemon (sparkling)', price: 'Start from £1.95', ingredients: '', image: 'https://www.cookrepublic.com/wp-content/uploads/2019/06/sparkling_iced_lemon_tea09.jpg' },
        { name: 'Ice Tea Green', price: 'Start from £1.95', ingredients: '', image: 'https://images.getrecipekit.com/20240517100915-iced-20green-20tea.jpg?class=16x9' },
        { name: 'Ice Tea Peach', price: 'Start from £1.95', ingredients: '', image: 'https://yousaypotatoes.com/wp-content/uploads/2022/06/peach-iced-tea-2.jpg' },
        { name: 'Water', price: 'Start from £1.95', ingredients: '', image: 'https://www.buxtonwater.co.uk/sites/g/files/xknfdk681/files/styles/ipp_bg_image_desktop/public/2022-01/Lead%20Still%20shot%20-%20Top%20of%20page.jpg.webp?itok=W1JORLMT' },
        { name: 'Sparkling Water', price: 'Start from £1.95', ingredients: '', image: 'https://www.fruit4london.co.uk/cdn/shop/products/S.Pellegrino-Sparkling-Water-1-Litre.jpg?v=1683266767' },
      ],
    },
    {
      id: 'milkshakes',
      name: 'Milkshakes',
      items: [
        { name: 'Vanilla', price: 'Start from £4.95', ingredients: '', image: 'https://cdn.pixabay.com/photo/2017/04/03/18/41/dessert-2199271_1280.jpg' },
        { name: 'Strawberry', price: 'Start from £4.95', ingredients: '', image: 'https://cdn.pixabay.com/photo/2017/07/20/20/22/smoothie-2523605_960_720.jpg' },
        { name: 'Chocolate', price: 'Start from £4.95', ingredients: '', image: 'https://cdn.pixabay.com/photo/2014/11/21/15/20/coffee-540653_1280.jpg' },
        { name: 'Biscoff', price: 'Start from £4.95', ingredients: '', image: 'https://thecinnamonjar.com/wp-content/uploads/2023/03/Biscoff-milkshake01790-3.jpg' },
        { name: 'Oreo', price: 'Start from £4.95', ingredients: '', image: 'https://saltandbaker.com/wp-content/uploads/2020/12/oreo-milkshake-recipe.jpg' },
      ],
    },
    {
      id: 'wok-and-fire',
      name: 'Wok & Fire – Build Your Box',
      items: [
        { name: 'Noodles', price: 5.45, ingredients: 'With Fresh Cabbage Mix, Onion Mix & Egg. Choose: Egg noodles, Whole - white noodles, Rice noodles, Udon noodles', image: 'https://cdn.pixabay.com/photo/2016/01/29/17/08/feast-noodles-1168322_960_720.jpg' },
        { name: 'Grains', price: 5.45, ingredients: 'Choose: Jasmine Rice, Whole - Grain Rice', image: 'https://cdn.pixabay.com/photo/2015/05/02/00/59/herbs-749360_1280.jpg' },
        { name: 'Vegetables (Stir-Fry)', price: 5.45, ingredients: 'Broccoli, Carrot, Mushroom, Onion, Pak Choi, Leek and Cabbage, Soya Edamame Beans', image: 'https://cdn.pixabay.com/photo/2018/03/18/20/06/vegetables-3238149_1280.jpg' },
        { name: 'Vegetable Stir Fry with Noodles/Rice', price: 9.95, ingredients: '', image: 'https://cdn.pixabay.com/photo/2014/03/11/17/05/fry-up-285360_1280.jpg' },
      ],
    },
  ];

  const baseOptions = [
    'Egg noodles',
    'Whole - white noodles',
    'Rice noodles',
    'Udon noodles',
    'Jasmine Rice',
    'Whole - Grain Rice',
  ];

  const favouritesOptions = [
    { name: 'Chicken Breast', price: 2.80 },
    { name: 'Chicken Tender', price: 2.95 },
    { name: 'Chicken Katsu', price: 2.95 },
    { name: 'Chicken Wings', price: 2.95 },
    { name: 'Beef', price: 2.95 },
    { name: 'Roast Duck', price: 2.95 },
    { name: 'Mixed Seafood', price: 2.95 },
    { name: 'Prawn', price: 2.95 },
    { name: 'King Prawn', price: 3.45 },
    { name: 'Broccoli', price: 2.25 },
    { name: 'Tofu', price: 1.80 },
    { name: 'Button Mushroom', price: 1.80 },
    { name: 'Pak Choi', price: 1.85 },
    { name: 'Cashew Nut', price: 1.80 },
    { name: 'Bamboo Shoot', price: 1.40 },
    { name: 'Mixed Peppers', price: 1.50 },
    { name: 'Baby Corn', price: 1.50 },
    { name: 'Red Onion', price: 1.50 },
    { name: 'Pineapple', price: 1.50 },
    { name: 'Soya Edamame Beans', price: 1.50 },
  ];

  const sauceOptions = [
    'Teriyaki',
    'Spicy Teriyaki',
    'Sweet & Sour',
    'Yellow Curry & Coconut',
    'Dark Soy & Ginger',
    'Asian Spice Sauce',
    'Hot Asia',
    'Garlic & Black Pepper',
    'Peanut Sauce',
    'Soya Sauce',
    'Sweet Chilli',
  ];

  const extraToppings = [
    { name: 'Fresh Coriander', price: 0.60 },
    { name: 'Fried Garlic', price: 0.60 },
    { name: 'Fried Onion', price: 0.60 },
    { name: 'Peanut', price: 0.60 },
    { name: 'Sesame Seeds', price: 0.60 },
  ];


  // -----------------------------
  // Helper Functions
  // -----------------------------
  const calculateTotalPrice = (items) => items.reduce((acc, curr) => {
    // Only add numeric prices to the total
    return typeof curr.price === 'number' ? acc + curr.price : acc;
  }, 0).toFixed(2);


  const addItemToSelected = (item) => {
    setSelectedItems((prev) => {
      const newArr = [...prev, item];
      setTotalPrice(calculateTotalPrice(newArr));
      return newArr;
    });
  };

  const removeItemFromSelected = (itemName) => {
    setSelectedItems((prev) => {
      const filtered = prev.filter((i) => i.name !== itemName);
      setTotalPrice(calculateTotalPrice(filtered));
      return filtered;
    });
  };

  const handleSelectItem = (item) => {
    const found = selectedItems.find((i) => i.name === item.name);
    if (found) removeItemFromSelected(item.name);
    else addItemToSelected(item);
  };

  const isMealReady = selectedBase && selectedFavourites.length > 0 && selectedSauce;

  const handleAddMeal = () => {
    if (!isMealReady) return;
    const basePrice = 5.45;
    const favouritesPrice = favouritesOptions.reduce((acc, fav) => {
      return selectedFavourites.includes(fav.name) ? acc + fav.price : acc;
    }, 0);
    const extrasPrice = selectedExtras.length * 0.6;
    const totalPrice = basePrice + favouritesPrice + extrasPrice;

    const meal = { name: 'WOK & FIRE Box', price: totalPrice };
    addItemToSelected(meal);

    setSelectedBase('');
    setSelectedFavourites([]);
    setSelectedSauce('');
    setSelectedExtras([]);
  };

  const toggleCategory = (category) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  // -----------------------------
  // Stripe Checkout
  // -----------------------------
  const createCheckoutSession = async (items) => {
    try {
      const response = await axios.post('http://localhost:8000/create-checkout-session', { items });
      const { url } = response.data;
      window.location.href = url;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      alert('There was an issue processing your payment. Please try again.');
    }
  };

  const handleAddToCart = () => {
    const cartItems = selectedItems.map((item) => ({
      name: item.name,
      price: item.price,
      quantity: 1,
    }));
    createCheckoutSession(cartItems);
  };

  // -----------------------------
  // Render
  // -----------------------------
  return (
    <div className="menu-container">
      <h2 className="menu-title">Wok & Fire Halal Menu</h2>

      {menuData.map((category) => {
        const isExpanded = expandedCategories[category.id] || false;
        const visibleItems = isMobileView
          ? (isExpanded ? category.items : category.items.slice(0, 4))
          : category.items;

        return (
          <div key={category.id} className="menu-section" id={category.id}>
            <h2 className="menu-section-title">{category.name}</h2>
            <div className="menu-items">
              {visibleItems.map((item, index) => (
                <div className="menu-card" key={index}>
                  <div className="card-image-container">
                    <img
                      src={item.image}
                      alt={`Food item name: ${item.name}`}
                      title={`Food item name: ${item.name}`}
                      loading="lazy"
                      onError={(e) => { e.target.src = 'https://via.placeholder.com/150'; }}
                    />
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">{item.name}</h3>
                    <p className="card-price">
                      {typeof item.price === 'number' ? `£${item.price.toFixed(2)}` : item.price}
                    </p>
                    <p className="card-ingredients">{item.ingredients}</p>
                    <button
                      className="card-button"
                      onClick={() => handleSelectItem(item)}
                      disabled={item.price === 'Coming Soon'}
                    >
                      {selectedItems.some((i) => i.name === item.name) ? 'Remove' :
                        (item.price === 'Coming Soon' ? 'Coming Soon' : 'Select')}
                    </button>
                  </div>
                </div>
              ))}
              {isMobileView && category.items.length > 4 && (
                <button
                  className="expand-button"
                  onClick={() => toggleCategory(category.id)}
                >
                  {isExpanded ? 'See Less' : 'See More'}
                </button>
              )}
            </div>
          </div>
        );
      })}

      {/* WOK & FIRE Build Your Box Section */}
      <div id="wok-fire-build-your-box" className="menu-section-2">
        <h2 className="menu-section-title">WOK & FIRE Build Your Box</h2>
        <div className="menu-build-your-own">
          {/* Step 1: Choose Base */}
          <div className="menu-subsection">
            <h3 className="step-title">⿡ Choose Your Base (with Fresh Veg & Egg)</h3>
            <p className="step-description">Includes: Broccoli, Carrot, Mushroom, Onion, Pak Choi, Leek, Cabbage, Soya Edamame Beans.</p>
            <div className="base-options">
              {baseOptions.map((option) => (
                <label key={option} className="menu-option base-option" htmlFor={`base-${option}`}>
                  <input
                    type="radio"
                    id={`base-${option}`}
                    name="base"
                    value={option}
                    checked={selectedBase === option}
                    onChange={(e) => setSelectedBase(e.target.value)}
                  />
                  {option}
                </label>
              ))}
            </div>
          </div>

          {/* Step 2: Choose Favourites */}
          <div className="menu-subsection">
            <h3 className="step-title">⿢ Choose Your Favourites</h3>
            <div className="favourites-options">
              {favouritesOptions.map((fav) => (
                <label key={fav.name} className="menu-option favourite-option" htmlFor={`favourite-${fav.name}`}>
                  <input
                    type="checkbox"
                    id={`favourite-${fav.name}`}
                    value={fav.name}
                    checked={selectedFavourites.includes(fav.name)}
                    onChange={() => {
                      setSelectedFavourites(
                        selectedFavourites.includes(fav.name)
                          ? selectedFavourites.filter((item) => item !== fav.name)
                          : [...selectedFavourites, fav.name]
                      );
                    }}
                  />
                  {fav.name} - £{fav.price.toFixed(2)}
                </label>
              ))}
            </div>
          </div>

          {/* Step 3: Choose Sauce */}
          <div className="menu-subsection">
            <h3 className="step-title">⿣ Choose Your Sauce (Free)</h3>
            <div className="sauce-options">
              {sauceOptions.map((sauce) => (
                <label key={sauce} className="menu-option sauce-option" htmlFor={`sauce-${sauce}`}>
                  <input
                    type="radio"
                    id={`sauce-${sauce}`}
                    name="sauce"
                    value={sauce}
                    checked={selectedSauce === sauce}
                    onChange={(e) => setSelectedSauce(e.target.value)}
                  />
                  {sauce}
                </label>
              ))}
            </div>
          </div>

          {/* Extra Toppings */}
          <div className="menu-subsection">
            <h3 className="step-title">🧂 Extras / Toppings - £0.60 Each</h3>
            <div className="extras-options">
              {extraToppings.map((extra) => (
                <label key={extra.name} className="menu-option extra-option" htmlFor={`extra-${extra.name}`}>
                  <input
                    type="checkbox"
                    id={`extra-${extra.name}`}
                    value={extra.name}
                    checked={selectedExtras.includes(extra.name)}
                    onChange={() => {
                      setSelectedExtras(
                        selectedExtras.includes(extra.name)
                          ? selectedExtras.filter((item) => item !== extra.name)
                          : [...selectedExtras, extra.name]
                      );
                    }}
                  />
                  {extra.name} - £{extra.price.toFixed(2)}
                </label>
              ))}
            </div>
          </div>

          <button className="add-meal-button" onClick={handleAddMeal} disabled={!isMealReady}>
            Add Box to Selection
          </button>
        </div>
      </div>

      {/* Selected Items Display */}
      {selectedItems.length > 0 && (
        <div className="selected-items">
          <h2 className="selected-items-title">Selected Items</h2>
          <ul className="menu-items-list">
            {selectedItems.map((item, index) => (
              <li key={index} className="selected-item">
                <span className="item-name">{item.name}</span>
                <span className="item-price">
                  {typeof item.price === 'number' ? `£${item.price.toFixed(2)}` : item.price}
                </span>
              </li>
            ))}
          </ul>
          <div className="total-price">
            <strong>Total: </strong>£{totalPrice}
          </div>
        </div>
      )}

      {/* Tagline */}
      <p className="menu-tagline">Quick bites, big delights</p>
    </div>
  );
};

export default RegularMenu;